
import axios from 'axios';


export async function downloadFileFromSignedUrl(signedUrl: string, filename: string): Promise<void> {
    try {
        const response = await axios.get(signedUrl, {
            responseType: 'blob',
        });

        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const downloadUrl = window.URL.createObjectURL(blob);

        // Create a link element
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename; // Specify the filename for download
        document.body.appendChild(a);
        a.click(); // Trigger the download
        a.remove(); // Clean up

        // Revoke the object URL to free up memory
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error: any) {
        throw new Error(error.message);
    }
}